<label class="form-label">Funcionario existente</label>
<app-busca-pesquisavel
  nomeCampo="buscaFuncionario"
  rotuloBuscar="Pesquisar funcionario"
  [termo]="termo"
  (termoChange)="termoChange.emit($event)"
  [itens]="funcionarios"
  [rotuloItem]="rotuloItem"
  [detalheItem]="detalheItem"
  (buscar)="buscar.emit()"
  (selecionar)="selecionar.emit($event)">
</app-busca-pesquisavel>
